import { Inject, Injectable, ViewContainerRef } from '@angular/core';

import { I18nService } from '@recruitee/i18n';
import { DialogRef, DialogService } from '@recruitee/user-interface';

import { TutorialDialogModuleTranslations, TutorialTranslations } from './translations';
import { TutorialDialogComponent } from './tutorial-dialog.component';
import { AssetsProvider, TutorialDialogContext, TutorialStep } from './tutorial-dialog.types';

@Injectable({ providedIn: 'root' })
export class TutorialDialogService {
  public readonly VIDEO_CALLING_CONFIG: TutorialStep[] = [
    {
      imgUrl: this.assetsProvider('video-calling/video-calling-step-1.png'),
      imgUrl2x: this.assetsProvider('video-calling/video-calling-step-1_2x.png'),
      title:
        this.translations.tutorials.video_calling &&
        this.i18n.translate(this.translations.tutorials.video_calling.step_1.title),
      description:
        this.translations.tutorials.video_calling &&
        this.i18n.translate(this.translations.tutorials.video_calling.step_1.description),
    },
    {
      imgUrl: this.assetsProvider('video-calling/video-calling-step-2.png'),
      imgUrl2x: this.assetsProvider('video-calling/video-calling-step-2_2x.png'),
      title:
        this.translations.tutorials.video_calling &&
        this.i18n.translate(this.translations.tutorials.video_calling.step_2.title),
      description:
        this.translations.tutorials.video_calling &&
        this.i18n.translate(this.translations.tutorials.video_calling.step_2.description),
    },
    {
      imgUrl: this.assetsProvider('video-calling/video-calling-step-3.png'),
      imgUrl2x: this.assetsProvider('video-calling/video-calling-step-3_2x.png'),
      title:
        this.translations.tutorials.video_calling &&
        this.i18n.translate(this.translations.tutorials.video_calling.step_3.title),
      description:
        this.translations.tutorials.video_calling &&
        this.i18n.translate(this.translations.tutorials.video_calling.step_3.description),
      link:
        'https://support.recruitee.com/recruitee-s-key-features-explained/using-video/get-started-with-video-calls-beta',
    },
  ];

  public readonly MULTILANG_INTRO_CONFIG: TutorialStep[] = [
    {
      imgUrl: this.assetsProvider('multilang-intro/multilang-intro-step-1.png'),
      imgUrl2x: this.assetsProvider('multilang-intro/multilang-intro-step-1_2x.png'),
      title:
        this.translations.tutorials.multilang_intro &&
        this.i18n.translate(this.translations.tutorials.multilang_intro.step_1.title),
      description:
        this.translations.tutorials.multilang_intro &&
        this.i18n.translate(this.translations.tutorials.multilang_intro.step_1.description),
    },
    {
      imgUrl: this.assetsProvider('multilang-intro/multilang-intro-step-2.png'),
      imgUrl2x: this.assetsProvider('multilang-intro/multilang-intro-step-2_2x.png'),
      title:
        this.translations.tutorials.multilang_intro &&
        this.i18n.translate(this.translations.tutorials.multilang_intro.step_2.title),
      description:
        this.translations.tutorials.multilang_intro &&
        this.i18n.translate(this.translations.tutorials.multilang_intro.step_2.description),
    },
    {
      imgUrl: this.assetsProvider('multilang-intro/multilang-intro-step-3.png'),
      imgUrl2x: this.assetsProvider('multilang-intro/multilang-intro-step-3_2x.png'),
      title:
        this.translations.tutorials.multilang_intro &&
        this.i18n.translate(this.translations.tutorials.multilang_intro.step_3.title),
      description:
        this.translations.tutorials.multilang_intro &&
        this.i18n.translate(this.translations.tutorials.multilang_intro.step_3.description),
    },
  ];

  public readonly MULTILANG_OFFER_CONFIG: TutorialStep[] = [
    {
      imgUrl: this.assetsProvider('multilang-offer/multilang-offer-step-1.png'),
      imgUrl2x: this.assetsProvider('multilang-offer/multilang-offer-step-1_2x.png'),
      title:
        this.translations.tutorials.multilang_offer &&
        this.i18n.translate(this.translations.tutorials.multilang_offer.step_1.title),
      description:
        this.translations.tutorials.multilang_offer &&
        this.i18n.translate(this.translations.tutorials.multilang_offer.step_1.description),
    },
    {
      imgUrl: this.assetsProvider('multilang-offer/multilang-offer-step-2.png'),
      imgUrl2x: this.assetsProvider('multilang-offer/multilang-offer-step-2_2x.png'),
      title:
        this.translations.tutorials.multilang_offer &&
        this.i18n.translate(this.translations.tutorials.multilang_offer.step_2.title),
      description:
        this.translations.tutorials.multilang_offer &&
        this.i18n.translate(this.translations.tutorials.multilang_offer.step_2.description),
    },
    {
      imgUrl: this.assetsProvider('multilang-offer/multilang-offer-step-3.png'),
      imgUrl2x: this.assetsProvider('multilang-offer/multilang-offer-step-3_2x.png'),
      title:
        this.translations.tutorials.multilang_offer &&
        this.i18n.translate(this.translations.tutorials.multilang_offer.step_3.title),
      description:
        this.translations.tutorials.multilang_offer &&
        this.i18n.translate(this.translations.tutorials.multilang_offer.step_3.description),
    },
  ];

  public readonly REFERRALS_ONBOARDING_CONFIG: TutorialStep[] = [
    {
      imgUrl: this.assetsProvider('referrals-onboarding/referrals-onboarding-step-2.png'),
      imgUrl2x: this.assetsProvider('referrals-onboarding/referrals-onboarding-step-2_2x.png'),
      title:
        this.translations.tutorials.referrals_onboarding &&
        this.i18n.translate(this.translations.tutorials.referrals_onboarding.step_2.title),
      description:
        this.translations.tutorials.referrals_onboarding &&
        this.i18n.translate(this.translations.tutorials.referrals_onboarding.step_2.description),
    },
    {
      imgUrl: this.assetsProvider('referrals-onboarding/referrals-onboarding-step-3.png'),
      imgUrl2x: this.assetsProvider('referrals-onboarding/referrals-onboarding-step-3_2x.png'),
      title:
        this.translations.tutorials.referrals_onboarding &&
        this.i18n.translate(this.translations.tutorials.referrals_onboarding.step_3.title),
      description:
        this.translations.tutorials.referrals_onboarding &&
        this.i18n.translate(this.translations.tutorials.referrals_onboarding.step_3.description),
    },
    {
      imgUrl: this.assetsProvider('referrals-onboarding/referrals-onboarding-step-4.png'),
      imgUrl2x: this.assetsProvider('referrals-onboarding/referrals-onboarding-step-4_2x.png'),
      title:
        this.translations.tutorials.referrals_onboarding &&
        this.i18n.translate(this.translations.tutorials.referrals_onboarding.step_4.title),
      description:
        this.translations.tutorials.referrals_onboarding &&
        this.i18n.translate(this.translations.tutorials.referrals_onboarding.step_4.description),
    },
  ];

  public tutorials: { [key in TutorialDialogContext]: TutorialStep[] } = {
    video_calling: this.VIDEO_CALLING_CONFIG,
    multilang_intro: this.MULTILANG_INTRO_CONFIG,
    multilang_offer: this.MULTILANG_OFFER_CONFIG,
    referrals_onboarding: this.REFERRALS_ONBOARDING_CONFIG,
  };

  private analyticsContextMap: { [key in TutorialDialogContext]: string } = {
    video_calling: '[ScheduleFirstStep]',
    multilang_intro: '[Settings/Langauges]',
    multilang_offer: '[OfferForm]',
    referrals_onboarding: '[ReferralsOnboarding]',
  };

  constructor(
    private dialogService: DialogService,
    private i18n: I18nService,
    @Inject(TutorialTranslations)
    public translations: TutorialDialogModuleTranslations,
    @Inject(AssetsProvider) private assetsProvider: (filePath: string) => string,
  ) {
    this.bindDialogGlobalTrigger();
  }

  public open(context: TutorialDialogContext, vcRef: ViewContainerRef): DialogRef {
    return this.dialogService.custom(
      TutorialDialogComponent,
      { width: '601px', showCloseButton: false },
      { config: this.tutorials[context], analyticsContext: this.analyticsContextMap[context] },
      vcRef,
    );
  }

  private bindDialogGlobalTrigger(): void {
    // @ts-ignore
    window['tutorialDialog'] = (context: TutorialDialogContext) => {
      this.open(context, <any>null);
    };
  }
}
